import { createContext, ReactNode, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

type Context = {
  isOpen: boolean;
  onToggle: () => void;

  isDevMode: boolean;
  onToggleDevMode: (e: KeyboardEvent) => void;
};

export const DashboardContext = createContext({} as Context);

type Props = {
  children: ReactNode;
};

export const DashboardProvider = ({ children }: Props) => {
  const [isDevMode, setIsDevMode] = useState(false);
  const onToggleDevMode = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDevMode((prev) => !prev);
  };

  const [isOpen, setIsOpen] = useState(true);
  const onToggle = () => setIsOpen(!isOpen);

  useHotkeys(
    `mod+backslash`,
    () => {
      setIsOpen((prev) => !prev);
    },
    { enableOnContentEditable: true, enableOnFormTags: true },
  );

  useHotkeys(['alt+shift+d', 'f1'], onToggleDevMode);

  return (
    <DashboardContext.Provider value={{ isOpen, onToggle, isDevMode, onToggleDevMode }}>
      {children}
    </DashboardContext.Provider>
  );
};
